module.exports = __webpack_public_path__ + "static/img/HeroBanner.0b4fbba2.png";